import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import { PdfTableHead, PdfTableRow, PdfTableFoot } from '../components/PdfTable';
import { fmtINR } from '../pdfUtils';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const COLS = [
  { label: 'Category',          flex: 2.5 },
  { label: 'Opening Bal (₹)',   flex: 1.2, align: 'right' },
  { label: 'Income (₹)',        flex: 1.2, align: 'right' },
  { label: 'Expense (₹)',       flex: 1.2, align: 'right' },
  { label: 'Closing Bal (₹)',   flex: 1.2, align: 'right' },
];

export default function CategoryFundDocument({ data, theme: themeKey, orientation, sections, filters }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const categories = Array.isArray(data.categories) ? data.categories : [];
  const commission = data.commission;

  const allRows = commission ? [...categories, { ...commission, category: 'Commission Fund' }] : categories;

  const totOpening = allRows.reduce((s, r) => s + Number(r.openingBalance || 0), 0);
  const totIncome  = allRows.reduce((s, r) => s + Number(r.income  || 0), 0);
  const totExpense = allRows.reduce((s, r) => s + Number(r.expense || 0), 0);
  const totClosing = allRows.reduce((s, r) => s + Number(r.closingBalance || 0), 0);

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'portrait'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Category Fund Report" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && <PdfFilterLine filters={filters} theme={t} />}
          <PdfTableHead cols={COLS} theme={t} />
          {allRows.map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t}
              values={[
                row.category || row.name || '—',
                fmtINR(row.openingBalance),
                fmtINR(row.income),
                fmtINR(row.expense),
                fmtINR(row.closingBalance),
              ]}
            />
          ))}
          <PdfTableFoot cols={COLS}
            values={['Total', fmtINR(totOpening), fmtINR(totIncome), fmtINR(totExpense), fmtINR(totClosing)]}
            theme={t}
          />
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}


